import { call, put, select } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { actions, selectors } from '../../Stream';
import { getCurrentMediaSource, getCurrentStreamId, getCurrentGallection, getCurrentSubfolderId, getGrusername } from '../selectors';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import { MediaSourceType } from '../types';
import { getGallectionType } from '../helpers';
function* moveDeviationToPosition(action) {
    const { deviation, position, moveType } = action.payload;
    const { streamId, currentMediaSource, currentGallection, currentSubfolderId, username } = yield select((state)=>({
            streamId: getCurrentStreamId(state),
            currentMediaSource: getCurrentMediaSource(state),
            currentGallection: getCurrentGallection(state),
            currentSubfolderId: getCurrentSubfolderId(state),
            username: getGrusername(state)
        }));
    const isFetching = yield select(selectors.isFetching, streamId);
    if (!moveType || moveType === 'streamOnly') {
        if (currentMediaSource !== MediaSourceType.CUSTOM_SET && isFetching) {
            return;
        }
        yield put(actions.moveItem({
            streamId,
            item: getDeviationEntityId(deviation),
            position
        }));
    }
    if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
        return;
    }
    if (!moveType || moveType === 'papiOnly') {
        if (!currentGallection) {
            return;
        }
        var _getGallectionType;
        const data = {
            username,
            type: (_getGallectionType = getGallectionType(currentGallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
            folderid: currentSubfolderId || currentGallection.folderId,
            deviationid: deviation.deviationId,
            position
        };
        yield call(requestPuppy, {
            method: 'post',
            url: 'gallection/folders/update_deviation_order',
            data
        });
    }
}
export default moveDeviationToPosition;

//# sourceMappingURL=moveDeviationToPosition.js.map